<template>
  <div
    :style="[$store.state.ban ? { top: '70px' } : { top: '0px' }]"
    class="loga-navigation"
  >
    <div class="loga-navigation__logo">
      <router-link to="/">
        <img :src="logo" class="logoooo" alt="logo" />
      </router-link>
    </div>

    <div class="loga-navigation__search--con" style="z-index: 100">
      <input
        v-model="search_input"
        @focus="onFocus"
        class="loga-navigation__search--con-inp"
        placeholder="جستجو در فروشگاه ..."
        type="text"
        @input="search"
      />
      <font-awesome-icon
        class="loga-navigation__search--con-svg"
        icon="search"
      />
      <font-awesome-icon
        @click="onBlur"
        class="loga-navigation__search--con-svg1"
        icon="times-circle"
      />
      <div
        class="loga-navigation__search--con-res"
        :style="this.hhhres ? 'height: auto; max-height:250px' : 'height: 0'"
      >
        <router-link
          v-for="(item, index) in results.cats"
          :key="index"
          :to="{ name: 'list', params: { id: item.slug } }"
          class="loga-navigation__search--con-res-item"
        >
          <font-awesome-icon icon="shapes" /> دسته بندی :
          {{ item.name }}
        </router-link>
        <router-link
          v-for="(item, index) in results.brands"
          :key="'A' + index"
          :to="{ name: 'list', params: { id: item.slug } }"
          class="loga-navigation__search--con-res-item"
        >
          <font-awesome-icon icon="shapes" /> برند :
          {{ item.fa_name }}
        </router-link>
        <router-link
          v-for="(item, index) in results.product"
          :key="'B' + index"
          :to="{ name: 'detail', params: { id: item.slug } }"
          class="loga-navigation__search--con-res-item"
        >
          {{ item.name }}</router-link
        >
      </div>
    </div>
    <a @click="profile" class="loga-navigation__login">
      <font-awesome-icon icon="user-edit" />
      <p v-if="!this.$store.state.islog">ورود به حساب کاربری</p>
      <p v-else>
        <span>
          {{ this.$store.state.name }}
        </span>
      </p>
    </a>

    <div class="loga-navigation__shop">
      <a class="loga-navigation__shop-link">
        <router-link to="/cart">
          <font-awesome-icon icon="shopping-cart" />
          <span class="shopping-co">{{
            this.$store.state.co.toLocaleString("fa")
          }}</span>
        </router-link>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "",
      login: false,
      logo: "",
      search_input: "",
      hhhres: false,
      results: {
        product: {},
        brands: {},
        cats: {},
      },
    };
  },
  watch: {
    $route(to, from) {
      this.$store.state.graybg = false;
      this.boom();
      this.search_input = "";
      if (localStorage.getItem("profile") != null) {
        this.$store.state.islog = true;
      }
    },
  },
  created() {
    var that = this;
    this.$store.state.name = localStorage.getItem("name");
    // console.log(this.$store.state.name, "cheraaaaaaaaaaaaaaaaaaaaa");
    if (localStorage.getItem("profile") != null) {
      this.$store.state.islog = true;
    }
    // console.log(localStorage.getItem("profile"));
    if (localStorage.getItem("profile") == null) {
      $.ajax({
        url: that.$store.state.url + "api/v1/pages/nav/",
        crossDomain: true,
        xhrFields: {
          withCredentials: true,
        },
        type: "GET",
        success: function (data, textStatus, request) {
          // console.log(data.logo, "hoooooooooooooooooooooooooooooooooooof");
          // console.log(data, "boom");
          that.$store.state.link = data.log;
          that.logo = data.logo;
          that.$store.state.looo = data.logo;
          if (data.cart_count) {
            that.$store.state.co = data.cart_count;
          }
        },
        error: function (request, textStatus, errorThrown) {
          if (request.state == 500) {
            that.$toastr.e("خطایی در سرور به وجود امده");
            that.$store.state.e500 = true;
          } else {
            that.$store.state.e404 = true;
            that.$toastr.e("خطا در برقراری ارتباط");
          }
        },
        complete: function () {},
      });
    } else {
      $.ajax({
        url: that.$store.state.url + "api/v1/pages/nav/",
        crossDomain: true,
        xhrFields: {
          withCredentials: true,
        },
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("profile"),
        },
        type: "GET",
        success: function (data, textStatus, request) {
          // console.log(data.logo, "hoooooooooooooooooooooooooooooooooooof");
          that.$store.state.looo = data.logo;
          that.logo = data.logo;
          if (data.cart_count) {
            that.$store.state.co = data.cart_count;
          }
        },
        error: function (request, textStatus, errorThrown) {
          if (request.state == 500) {
            that.$toastr.e("خطایی در سرور به وجود امده");
            that.$store.state.e500 = true;
          } else {
            that.$store.state.e404 = true;
            that.$toastr.e("خطا در برقراری ارتباط");
          }
        },
        complete: function () {},
      });
    }
  },
  methods: {
    search(event) {
      // console.log(event)
      this.onFocus();
      var that = this;
      $.ajax({
        url:
          that.$store.state.url +
          "api/v1/products/main-search-dynamic-count/?q=" +
          this.search_input +
          "&prod_count=" +
          20 +
          "&cat_count=" +
          5 +
          "&brand_count=" +
          3,
        crossDomain: true,
        xhrFields: {
          withCredentials: true,
        },
        type: "GET",
        success: function (data, textStatus, request) {
          // console.log(data, "Ohhhhhhhhhhhhhhhhhhhhhhhhhhh");
          that.hhhres = true;
          if (data.cats) {
            that.results.cats = data.cats;
          }
          if (data.brands) {
            that.results.brands = data.brands;
          }
          if (data.products) {
            that.results.product = data.products;
          }
          if (data.length == 0) {
            that.hhhres = false;
          }
        },
        error: function (request, textStatus, errorThrown) {},
        complete: function () {},
      });
    },
    profile() {
      if (localStorage.getItem("profile") != null) {
        this.$router.push("/profile");
      } else {
        this.$router.push("/login");
      }
    },
    close_search() {
      // console.log("empty");

      this.search_input = "";
    },

    boom() {
      this.$store.state.graybg = false;
      // console.log(this.$store.state.graybg);
      this.results.cats = undefined;
      this.results.brands = undefined;
      this.results.product = undefined;
      this.hhhres = false;
      $(".loga-navigation__search--con").css("background-color", "transparent");
      $(".loga-navigation__search--con").css(
        "box-shadow",
        "0 0 5px rgba(0, 0, 0, 0)"
      );
      // console.log(window.outerWidth);
      if (window.outerWidth <= 500) {
        $(".loga-navigation__search--con").css("height", "20px");
      } else {
        $(".loga-navigation__search--con").css("height", "50px");
      }
      $(".loga-navigation__search--con-inp").css(
        "background-color",
        "var(--bg-color)"
      );
      $(".loga-navigation__search--con-svg1").css("display", "none");
    },
    onFocus() {
      this.$store.state.graybg = true;

      // console.log("in");
      $(".loga-navigation__search--con").css(
        "background-color",
        "var(--main-color)"
      );
      $(".loga-navigation__search--con").css(
        "box-shadow",
        "0 0 5px rgba(0, 0, 0, 0.095)"
      );

      $(".loga-navigation__search--con").css("height", "auto");
      $(".loga-navigation__search--con-inp").css(
        "background-color",
        "var(--main-color)"
      );
      $(".loga-navigation__search--con-svg1").css("display", "block");
    },
    onBlur() {
      this.$store.state.graybg = false;
      // console.log(this.$store.state.graybg);
      this.results.cats = undefined;
      this.results.brands = undefined;
      this.results.product = undefined;
      this.hhhres = false;
      $(".loga-navigation__search--con").css("background-color", "transparent");
      $(".loga-navigation__search--con").css(
        "box-shadow",
        "0 0 5px rgba(0, 0, 0, 0)"
      );
      // console.log(window.outerWidth);
      if (window.outerWidth <= 500) {
        $(".loga-navigation__search--con").css("height", "20px");
      } else {
        $(".loga-navigation__search--con").css("height", "50px");
      }
      $(".loga-navigation__search--con-inp").css(
        "background-color",
        "var(--bg-color)"
      );
      $(".loga-navigation__search--con-svg1").css("display", "none");
    },
  },
};
</script>
<style lang="scss" scoped>
hr {
  width: 95%;
  border: none;
  height: 1px;
  background-color: #cfd8dc;
  margin-right: auto;
  margin-left: auto;
}
.loga-navigation {
  direction: rtl;
  display: flex;
  position: fixed;
  align-items: center;
  z-index: 100;
  top: 70px;
  width: 100%;
  height: 75px;
  background: var(--main-color);
  .logoooo {
    width: 60px;
    margin-top: 0.8em;
    border-radius: 50%;
    @media screen and (max-width: 900px) {
      width: 40px;
      margin-top: 0.5em;
      margin-right: -1em;
    }
    @media screen and (max-width: 500px) {
      width: 40px;
      margin-top: 0.5em;
      margin-right: -1em;
    }
  }
  // box-shadow: 0 0 5px rgba(0, 0, 0, 0.295);
  &__shop {
    &-link {
      text-decoration: none;
      margin-left: 1em;
      padding-right: 1em;
      border-right: 1px solid var(--bg-color);
      @media screen and (max-width: 500px) {
        margin-left: 0.3em;
      }
      @media screen and (max-width: 800px) {
        margin-left: 0.3em;
      }
      .shopping-cart {
        position: relative;
      }
      .shopping-co {
        padding: 0.2em;
        position: absolute;
        background: var(--sub-color);
        color: var(--main-color);
        width: 17px;
        font-size: 0.9em;
        height: 17px;
        top: 50%;
        transform: translate(-50%);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 0.35em;
        padding-left: 0.3em;
        @media screen and (max-width: 500px) {
          width: 15px;
          font-size: 0.7em;
          height: 15px;
          padding: 0.1em;
        }
        @media screen and (max-width: 800px) {
          width: 15px;
          font-size: 0.7em;
          height: 15px;
          padding: 0.1em;
        }
      }
      svg {
        color: var(--font-color);
        font-size: 1.5em;
        @media screen and (max-width: 500px) {
          font-size: 1em;
        }
        @media screen and (max-width: 800px) {
          font-size: 1.2em;
        }
      }
    }
  }
  &__login {
    cursor: pointer;
    display: flex;
    justify-self: flex-end;
    margin-right: auto;
    margin-left: 1em;
    // background: red;
    border: 1px solid var(--bg-color);
    border-radius: 10px;
    padding: 1em 1.5em;
    font-size: 0.8em;
    text-decoration: none;
    color: var(--font-color);
    font-family: "yekan";
    font-weight: thin;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 600px) {
      width: 120px;
      height: 20px;
      margin-top: 0;
      padding: 0.25em 0.5em;
      font-size: 0.6em;
      border-radius: 5px;
    }
    @media screen and (max-width: 500px) {
      width: 100px;
      height: 20px;

      margin-top: 0;
      padding: 0.25em 0em;
      font-size: 0.5em;
      border-radius: 5px;
    }
    svg {
      margin-left: 0.5em;
    }
  }
  &__logo {
    color: var(--sub-color);
    font-family: "lalezar";
    margin-right: 2em;
    font-size: 1.5em;
    text-shadow: 0 0 1px var(--shrink);
  }
  &__search--con {
    border-radius: 10px;
    // background: red;
    display: flex;
    direction: rtl;
    margin-right: 0em;
    position: absolute;
    height: 50px;
    width: 545px;
    margin-top: 5em;
    top: -86%;
    overflow: hidden;
    transform: translate(-28%, -2%);

    @media screen and (max-width: 1000px) {
      width: 400px;
      // height: 40px;
      margin-top: 4.9em;
      margin-right: 0.5em;
      height: 40px;
    }
    @media screen and (max-width: 900px) {
      width: 400px;
      // height: 40px;
      margin-top: 4.9em;
      margin-right: 0.5em;
      height: 40px;
    }
    @media screen and (max-width: 800px) {
      width: 400px;
      // height: 40px;
      margin-top: 5.1em;
      margin-right: -1em;
      height: 40px;
    }
    @media screen and (max-width: 700px) {
      width: 300px;
      // height: 40px;
      margin-top: 4.9em;
      margin-right: 0em;
      height: 40px;
    }
    @media screen and (max-width: 600px) {
      width: 250px;
      // height: 40px;
      margin-top: 5.5em;
      margin-right: 0.5em;
      height: 30px;
    }
    @media screen and (max-width: 500px) {
      width: 200px;
      height: 20px;
      margin-top: 5.8em;
      margin-right: 2em;
      height: 20px;
      // overflow: visible;
      // background: red;
      // display: none;
    }
    @media screen and (max-width: 400px) {
      width: 130px;
      height: 20px;
      margin-top: 5.8em;
      margin-right: 2em;
      height: 20px;
      // overflow: visible;
      // background: red;
      // display: none;
    }
    &-res {
      margin-top: 50px;
      display: flex;
      flex-direction: column;
      // padding: 0 0 1em 0;
      width: 100%;
      height: auto;
      max-height: 2500px;
      overflow: scroll;
      @media screen and (max-width: 900px) {
        // font-size: 0.8em;
        // padding: 0 0 0.5em 0;
        margin-top: 45px;
      }
      @media screen and (max-width: 600px) {
        // font-size: 0.8em;
        // padding: 0 0 0.5em 0;
        margin-top: 37px;
      }
      @media screen and (max-width: 500px) {
        font-size: 0.8em;
        // padding: 0 0 0.5em 0;
        margin-top: 25px;
      }
      &-item {
        width: 100%;
        // background: red;
        text-decoration: none;
        padding: 1em 2em;
        color: var(--font-color);
        font-size: 0.9em;
        @media screen and (max-width: 700px) {
          padding: 0.5em 1em;
          font-size: 0.7em;
        }
        @media screen and (max-width: 600px) {
          padding: 0.5em 1em;
          font-size: 0.6em;
        }
        @media screen and (max-width: 500px) {
          padding: 0.5em 1em;
          font-size: 0.5em;
        }
        svg {
          // background: red;
          color: var(--sub-color);
          margin-left: 0.5em;
        }
        &:hover {
          background: var(--hover-color);
        }
      }
    }
    &-svg {
      font-size: 1.4em;
      position: absolute;
      right: 2%;
      top: 64px;
      transform: translate(-8px, -50px);
      font-weight: thin;
      color: rgb(172, 172, 172);
      @media screen and (max-width: 900px) {
        font-size: 1em;
        top: 63px;
        left: 30px;
      }
      @media screen and (max-width: 800px) {
        font-size: 1em;
        top: 63px;
        left: 30px;
      }
      @media screen and (max-width: 600px) {
        font-size: 1em;
        top: 56px;
      }
      @media screen and (max-width: 500px) {
        font-size: 0.7em;
        top: 56px;
      }
    }
    &-svg1 {
      font-size: 1.4em;
      position: absolute;
      left: 5%;
      top: 64px;
      transform: translate(-8px, -50px);
      font-weight: thin;
      color: var(--shrink);
      display: none;
      cursor: pointer;
      @media screen and (max-width: 900px) {
        font-size: 1em;
        top: 63px;
        left: 20px;
      }
      @media screen and (max-width: 800px) {
        font-size: 1em;
        top: 63px;
        left: 20px;
      }
      @media screen and (max-width: 600px) {
        font-size: 1em;
        top: 60px;
      }
      @media screen and (max-width: 500px) {
        font-size: 0.7em;
        top: 56px;
        left: 10%;
      }
    }
    &-inp {
      color: rgb(87, 87, 87);
      font-family: "yekan";
      width: 100%;
      padding-right: 4em;
      border-radius: 10px;
      border: none;
      height: 50px;
      position: absolute;
      top: 0px;
      background: var(--bg-color);
      @media screen and (max-width: 900px) {
        // padding-right: 0.9em;
        // border-radius: 2px !important;
        font-size: 0.8em;
        height: 40px;
        // padding-bottom: 0.5em;
        // padding-right: 0em;
        // padding-bottom: 3.5em;
        padding-right: 3.5em;
      }
      @media screen and (max-width: 800px) {
        // padding-right: 0.9em;
        // border-radius: 2px !important;
        font-size: 0.8em;
        height: 40px;
        // padding-bottom: 0.5em;
        // padding-right: 0em;
        // padding-bottom: 3.5em;
        padding-right: 3.5em;
      }
      @media screen and (max-width: 600px) {
        // padding-right: 0.5em;
        // border-radius: 2px !important;
        font-size: 0.8em;
        height: 30px;
        // padding-bottom: 0.5em;
        // padding-right: 0em;
        // padding-bottom: 3.5em;
        padding-right: 2.7em;
      }
      @media screen and (max-width: 500px) {
        // padding-right: 0.5em;
        // border-radius: 2px !important;
        font-size: 0.5em;
        height: 20px;
        padding-right: 0em;
        // padding-bottom: 3.5em;
        padding-right: 3.5em;
      }
      // background: red;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/nav.vue